@if (showInfoCard) {
  @if (workspace$ | async; as workspace) {
    @if (settings$ | async; as settings) {
      @if (!(isPinned$ | async)) {
        <ng-container
          *ngTemplateOutlet="infoCardTpl; context: { workspace: workspace, settings: settings }"
        ></ng-container>
      }
    }
  }

  <ng-template #infoCardTpl let-workspace="workspace" let-settings="settings">
    <div
      class="info-card-wrapper"
      [class.info-card-wrapper--toolbar]="(isPinned$ | async) === true"
      [class.scrolling]="pinnedInfoScrollTransparencyEffect && isScrolling"
    >
      <ion-card>
        <ion-card-header>
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
              gap: 1rem;
            "
          >
            @if (workspace.thumbnailUrl) {
              <ion-thumbnail class="workspace-thumbnail">
                <ion-img
                  [src]="workspace.thumbnailUrl"
                  (ionError)="workspace.thumbnailUrl = undefined"
                  (ionImgDidLoad)="$event.target.classList.add('loaded')"
                  class="thumbnail-image"
                ></ion-img>
              </ion-thumbnail>
            } @else {
              <ion-icon name="file-tray-stacked" class="workspace-fallback-icon"></ion-icon>
            }
            <div style="flex: 1">
              <ion-card-title>{{ workspace.name }}</ion-card-title>
              @if (settings.showFirestoreIds) {
                <ion-card-subtitle>
                  ID: {{ workspace.id || (workspaceId$ | async) }}
                </ion-card-subtitle>
              }
            </div>
            <div style="display: flex; align-items: center; gap: 0.5rem">
              <ion-button
                fill="clear"
                size="small"
                (click)="togglePin()"
                [attr.aria-label]="
                  (isPinned$ | async) ? 'Unpin workspace info' : 'Pin workspace info'
                "
              >
                <ion-icon
                  [name]="(isPinned$ | async) ? 'remove-circle' : 'pin'"
                  slot="icon-only"
                ></ion-icon>
              </ion-button>
            </div>
          </div>
        </ion-card-header>
      </ion-card>
    </div>
  </ng-template>
}
